import React, { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ButtonPurple from 'components/design/Form/ButtonPurple'
import style from './style.module.scss'

const UpgradePlanCard = () => {
  const history = useHistory()
  const apps = useSelector(state => state.apps)
  const { activeBuilderAgent } = apps

  const canNavigate = useMemo(
    () => Boolean(apps.active?.id && activeBuilderAgent?.uid),
    [apps.active?.id, activeBuilderAgent?.uid]
  )

  const handleUpgradeClick = useCallback(() => {
    if (canNavigate) {
      history.push(`/app/${apps.active.id}/ai-agents/${activeBuilderAgent.uid}/pricing`)
    }
  }, [canNavigate, history, apps.active?.id, activeBuilderAgent?.uid])

  return (
    <div className={style.upgradePlanCard}>
      <div className={style.cardHeader}>
        <div className={style.iconContainer}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={style.icon}
            aria-hidden="true"
          >
            <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
            <path d="M20 2v4" />
            <path d="M22 4h-4" />
            <circle cx="4" cy="20" r="2" />
          </svg>
        </div>
        <div className={style.headerContent}>
          <div className={style.titleRow}>
            <span className={style.title}>Free Trial</span>
            <span className={style.activeBadge}>Active</span>
          </div>
          <div className={style.credits}>1,000 credits included</div>
        </div>
      </div>
      <ButtonPurple
        onClick={handleUpgradeClick}
        buttonText="Upgrade Plan"
        htmlType="button"
        holderStyles={{ width: '100%', marginBottom: 0 }}
        buttonStyles={{
          width: '100%',
          backgroundColor: 'rgb(243, 241, 253)',
          border: '1px solid rgb(104, 82, 214)',
          color: 'rgb(104, 82, 214)',
        }}
        disabled={!canNavigate}
      />
    </div>
  )
}

export default UpgradePlanCard
